import React from 'react'
import styles from '../styles.module.css'
import StaffingTable from './Tables/StaffingTable'
import PedagogicalTable from './Tables/PedagogicalTable'
import AwardsTable from './Tables/AwardsTable'


const byId = (rows) => Object.fromEntries((rows || []).map(r => [r.organizationId, r]))


const Table = ({ data }) => {
  if (!data || (!data.staffing && !data.pedagogical && !data.awards)) return null

  const staffingRows = data.staffing?.rows || []
  const pedById = byId(data.pedagogical?.rows)
  const awardsById = byId(data.awards?.rows)

  if (!staffingRows.length) return null

  return (
    <div className={styles.tableBlock}>
      {staffingRows.map(org => {
        const orgId = org.organizationId
        const ped = pedById[orgId]
        const aw = awardsById[orgId]
        return (
          <div key={orgId} className={styles.orgBlock}>
            <StaffingTable row={org} />
            {ped && <PedagogicalTable row={ped} />}
            {aw && <AwardsTable row={aw} />}
          </div>
        )
      })}
    </div>
  )
}

export default Table
